import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action";
import { Qualifier } from "../../internal/qualifier/Qualifier";
import { QualifierValue } from "../../internal/qualifier/QualifierValue";
import { clip, clipEvenOdd } from "../../qualifiers/flag";
/**
 * @description  Defines the clipping path to use when trimming pixels.
 * @extends SDK.Action
 * @memberOf Actions.PSDTools
 * @see Visit {@link Actions.PSDTools| PSDTools} for an example
 */

var ClipAction = /*#__PURE__*/function (_Action) {
  _inherits(ClipAction, _Action);

  var _super = _createSuper(ClipAction);

  function ClipAction() {
    var _this;

    _classCallCheck(this, ClipAction);

    _this = _super.call(this);
    _this.isEvenOdd = false;
    return _this;
  }
  /**
   * @description The name of the path to clip by
   * @param {string} path
   * @return {this}
   */


  _createClass(ClipAction, [{
    key: "byName",
    value: function byName(path) {
      this.path = path;
      return this;
    }
    /**
     * @description The index of the path to clip by
     * @param {number} path
     * @return {this}
     */

  }, {
    key: "byIndex",
    value: function byIndex(path) {
      this.path = path;
      return this;
    }
    /**
     * @description Trims pixels according to a clipping path included in the original image using an evenodd clipping rule.
     * @return {this}
     */

  }, {
    key: "evenOdd",
    value: function evenOdd() {
      this.isEvenOdd = true;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue;

      if (typeof this.path === 'string') {
        qualifierValue = new QualifierValue(['name', this.path]).setDelimiter(':');
      } else {
        qualifierValue = new QualifierValue(this.path);
      } //handles flag


      if (this.isEvenOdd) {
        this.addFlag(clipEvenOdd());
      } else {
        this.addFlag(clip());
      }

      this.addQualifier(new Qualifier('pg', qualifierValue));
      return this;
    }
  }]);

  return ClipAction;
}(Action);

export { ClipAction };